export const defaultValue = {
    id: '',
    company: '',
    roleName: '',
    description: '',
    active: true,
    isCallCenterRelated: true,
    permissions: [],
    createdBy: '',
    createdDate: null,
    lastModifiedBy: '',
    lastModifiedDate: null,
};
